$(function () {
  if (!customElements.get('subscribe-success-popup')) {
    customElements.define(
      'subscribe-success-popup',
      class subscribeSuccessPopup extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const root = $(this);
          const $affirmDom = root.find('.button_affirm');
          const $popupDom = root.find('.success_popup');
          const $iconDom = root.find('.icon_success');

          if ($affirmDom.length) {
            $affirmDom.on('click', () => {
              $popupDom.hide();
              history.replaceState(null, '', window.location.pathname);
            });
          }

          if ($iconDom.length) {
            setTimeout(() => {
              $iconDom.click();
            }, 1000);
          }
        }
      }
    );
  }
});
